import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "m10.62 3.99-7.63 7.634a.5.5 0 0 0-.147.353v1.886a.5.5 0 0 0 .5.5h1.886a.5.5 0 0 0 .353-.147l7.632-7.631M10.62 3.99l2.888-2.887a.5.5 0 0 1 .707 0L16.1 2.989a.5.5 0 0 1 0 .707l-2.888 2.888M10.62 3.99l2.593 2.593"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M.75 17.83h16.5"
    }, null, -1)
  ]))]))
}
export default { render: render }